var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.msg.chatType === 1
    ? _c("answer", {
        attrs: {
          isWaitAnswer: _vm.isWaitAnswer,
          "show-portrait": _vm.fullscreen,
          fullscreen: _vm.fullscreen,
          msg: _vm.msg,
        },
        on: {
          resend: (val) => _vm.$emit("resend", val),
          feedback: function ($event) {
            return _vm.$emit("feedback")
          },
        },
      })
    : _vm.msg.chatType === 0
    ? _c("question", {
        attrs: {
          "show-portrait": _vm.fullscreen,
          fullscreen: _vm.fullscreen,
          msg: _vm.msg.content,
        },
        on: {
          resend: function ($event) {
            return _vm.$emit("resend")
          },
        },
      })
    : _c("div", { staticClass: "system-msg" }, [
        _vm._v(_vm._s(_vm.msg.content)),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }